// System-wide banner fetch. Backed by GET /system/banner which reads a
// single S3 object (`system/banner.json` in the jobs bucket) — see
// lambda-start-job/system_banner.go for the contract.
//
// Public endpoint, no auth. Cached at the API for 30s so per-page-load
// fetches on the client don't hammer S3.

import { environment } from '../config/environment';

export interface SystemBanner {
  active: boolean;
  message?: string;
  until?: string;          // RFC3339 timestamp; frontend renders a countdown
  disableUpgrades?: boolean; // gates plan-upgrade and Stripe checkout CTAs
}

export const fetchSystemBanner = async (
  signal?: AbortSignal,
): Promise<SystemBanner> => {
  const base = environment.apiBaseUrl;
  if (!base) return { active: false };
  try {
    const resp = await fetch(`${base}/system/banner`, { signal });
    if (!resp.ok) return { active: false };
    return (await resp.json()) as SystemBanner;
  } catch {
    // Silent — a broken banner endpoint should never crash the app,
    // only miss showing a legitimate banner. Next poll retries.
    return { active: false };
  }
};
